import React, { Component, Suspense, lazy } from 'react'
import { Switch, Route } from 'react-router'
import { Router } from 'react-router-dom'
import { history } from './history'

import 'animate.css/animate.min.css'

import AppRoutes from './Routes'
const PageHeader = lazy(() => import('./components/PageHeader'))
const MMenu = lazy(() => import('./components/MMenu'))
const Mobilenav = lazy(() => import('./components/Mobilenav'))
const Gdpr = lazy(() => import('./components/pages/Gdpr'))
const Terms = lazy(() => import('./components/pages/Terms'))
const Privacy = lazy(() => import('./components/pages/Privacy'))
const CommGuide = lazy(() => import('./components/pages/CommunityGuidelines'))
const Contact = lazy(() => import('./components/pages/Contact'))
const WhyStellar = lazy(() => import('./components/pages/WhyStellar'))
const Team = lazy(() => import('./components/pages/Team'))
const About = lazy(() => import('./components/pages/About'))
const Home = lazy(() => import('./components/Home'))
const PrivateRoute = lazy(() =>
    import('./components/Authentication/privateRoute')
)
const AuthRoute = lazy(() => import('./components/Authentication/AuthRoute'))
// const ConditionalRoute = lazy(() =>
//   import("./components/Authentication/conditionalRoute")
// );
const History = lazy(() => import('./components/Authentication/History'))
const Signup = lazy(() => import('./components/Authentication/Signup'))
const ForgotPass = lazy(() => import('./components/Authentication/ForgotPass'))
const ChangePass = lazy(() =>
    import('./components/Authentication/ChangePassword')
)
const AccountSettings = lazy(() =>
    import('./components/Authentication/AccountSettings')
)
const AccessHistory = lazy(() =>
    import('./components/Authentication/AccessHistory')
)
const TokenHistory = lazy(() =>
    import('./components/Authentication/TokenHistory')
)

const GoogleOauthReturn = lazy(() =>
    import('./components/Oauth/google/oauthReturn')
)
const Faq = lazy(() => import('./components/pages/Faq'))
const Refredirect = lazy(() => import('./components/Refredirect'))

const Creator = lazy(() => import('./components/Creator'))
const Creators = lazy(() => import('./components/Creators'))
const Workflow = lazy(() => import('./components/Workflow'))
const Security = lazy(() => import('./components/pages/Security'))
const FooterLinks = lazy(() => import('./components/FooterLinks'))
const FooterCredits = lazy(() => import('./components/FooterCredits'))
const Authentication = lazy(() => import('./components/Authentication'))
const Dashboard = lazy(() => import('./components/Authentication/Dashboard'))
const Deposit = lazy(() => import('./components/Authentication/Deposit'))
const ProfileEdit = lazy(() =>
    import('./components/Authentication/ProfileEdit')
)
const Withdraw = lazy(() => import('./components/Authentication/Withdraw'))
const ResetPassword = lazy(() =>
    import('./components/Authentication/ResetPassword')
)
const Akolades = lazy(() => import('./components/Authentication/AkoladeList'))
const Referral = lazy(() => import('./components/Authentication/Referral'))

const GenericNotFound = lazy(() => import('./components/GenericNotFound'))
const CreateApp = lazy(() => import('./components/Authentication/CreateApp'))
const ListApp = lazy(() => import('./components/Authentication/ListApp'))
const ConfirmAppTxn = lazy(() =>
    import('./components/Authentication/ConfirmAppTxn')
)
// if (process.env.NODE_ENV !== "production") {
//   const { whyDidYouUpdate } = require("why-did-you-update");
//   whyDidYouUpdate(React);
// }

class App extends Component {
    render() {
        return (
            <Router history={history}>
                <Suspense
                    fallback={
                        <div className="ui active centered inline centerMiddle loader">
                            loading...
                        </div>
                    }>
                    <>
                        <PageHeader />
                        <MMenu />
                        <Switch>
                            <Route
                                exact
                                path={AppRoutes.home}
                                component={Home}
                            />
                            <Route
                                exact
                                path={AppRoutes.mobilenav}
                                component={Mobilenav}
                            />
                            <Route
                                exact
                                path={AppRoutes.about}
                                component={About}
                            />
                            <Route
                                exact
                                path={AppRoutes.team}
                                component={Team}
                            />
                            <Route
                                exact
                                path={AppRoutes.creators}
                                component={Creators}
                            />
                            <Route
                                exact
                                path={AppRoutes.whyStellar}
                                component={WhyStellar}
                            />
                            <Route
                                exact
                                path={AppRoutes.contact}
                                component={Contact}
                            />
                            <Route
                                exact
                                path={AppRoutes.privacy}
                                component={Privacy}
                            />
                            <Route
                                exact
                                path={AppRoutes.terms}
                                component={Terms}
                            />
                            <Route
                                exact
                                path={AppRoutes.gdpr}
                                component={Gdpr}
                            />
                            <Route exact path={AppRoutes.faq} component={Faq} />
                            <Route
                                exact
                                path={AppRoutes.security}
                                component={Security}
                            />
                            <Route
                                exact
                                path={AppRoutes.CommGuide}
                                component={CommGuide}
                            />
                            <Route
                                exact
                                path={AppRoutes.howitworks}
                                component={Workflow}
                            />

                            <Route
                                exact
                                path={AppRoutes.refredirect}
                                component={Refredirect}
                            />

                            <AuthRoute
                                exact
                                path={AppRoutes.login}
                                component={Authentication}
                            />
                            <AuthRoute
                                exact
                                path={AppRoutes.signup}
                                component={Signup}
                            />
                            <AuthRoute
                                exact
                                path={AppRoutes.forgotpass}
                                component={ForgotPass}
                            />

                            <PrivateRoute
                                exact
                                path={AppRoutes.dashboard}
                                component={Dashboard}
                            />
                            <PrivateRoute
                                exact
                                path={AppRoutes.deposit}
                                component={Deposit}
                            />
                            <PrivateRoute
                                exact
                                path={AppRoutes.profileedit}
                                component={ProfileEdit}
                            />
                            <PrivateRoute
                                exact
                                path={AppRoutes.withdraw}
                                component={Withdraw}
                            />
                            <PrivateRoute
                                exact
                                path={AppRoutes.history}
                                component={History}
                            />
                            <PrivateRoute
                                exact
                                path={AppRoutes.tokenhistory}
                                component={TokenHistory}
                            />
                            <PrivateRoute
                                exact
                                path={AppRoutes.changepas}
                                component={ChangePass}
                            />
                            <PrivateRoute
                                exact
                                path={AppRoutes.accsett}
                                component={AccountSettings}
                            />

                            <PrivateRoute
                                exact
                                path={AppRoutes.referrals}
                                component={Referral}
                            />

                            <PrivateRoute
                                exact
                                path={AppRoutes.acchistry}
                                component={AccessHistory}
                            />
                            <PrivateRoute
                                exact
                                path={AppRoutes.google}
                                component={GoogleOauthReturn}
                            />
                            <PrivateRoute
                                exact
                                path={AppRoutes.createapp}
                                component={CreateApp}
                            />
                            <PrivateRoute
                                exact
                                path={AppRoutes.listapp}
                                component={ListApp}
                            />
                            <PrivateRoute
                                exact
                                path={AppRoutes.confirmapptxn}
                                component={ConfirmAppTxn}
                            />
                            <Route
                                exact
                                strict
                                path={AppRoutes.user}
                                component={Creator}
                            />

                            <Route
                                exact
                                strict
                                path={AppRoutes.akolades}
                                component={Akolades}
                            />

                            <Route
                                exact
                                strict
                                path={AppRoutes.resetpass}
                                component={ResetPassword}
                            />
                            <Route component={GenericNotFound} />
                        </Switch>
                        <div className="footer-wrap">
                            <FooterLinks />
                            <FooterCredits />
                        </div>
                    </>
                </Suspense>
            </Router>
        )
    }
}

export default App
